var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('h4',[_vm._v(_vm._s(_vm.$t('bookings.rejected_assignments')))])]),_c('b-card-body',[_c('b-table',{attrs:{"items":_vm.assignments,"fields":_vm.fields,"responsive":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }